import { safeDefine } from '@breuni-ui/safe-define';
import { EntsModal } from '../modal/modal.js';
import { VSP_OPEN_EVENT, VspOpenEventDetail } from './vsp-event.js';

export { VSP_OPEN_EVENT };
export type { VspOpenEventDetail };

export class VspModal extends EntsModal {
  private readonly onOpen = (event: Event) => this.handleOpen(event as CustomEvent<VspOpenEventDetail>);

  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(VSP_OPEN_EVENT, this.onOpen);
  }

  disconnectedCallback() {
    document.removeEventListener(VSP_OPEN_EVENT, this.onOpen);
    super.disconnectedCallback();
  }

  private handleOpen(event: CustomEvent<VspOpenEventDetail>) {
    const { syan, colorId } = event.detail;
    const loader = this.querySelector('reco-vsp-loader');
    if (loader) {
      loader.setAttribute('syan', String(syan));
      if (colorId) {
        loader.setAttribute('color-id', colorId);
      } else {
        loader.removeAttribute('color-id');
      }
    }
    this.classList.remove('hidden');
    this.show();
  }
}

safeDefine('ents-vsp-modal', VspModal);
